<template>
    <div class="login">
        <div style="width: 100%;justify-content: center;
    height: 40rem;flex-direction: column; display: flex;align-items: center;background: #fff;">
            <img :src='require("@/assets/images/mobile_login.svg")' style="width: 15rem;height: 15rem;">
            <span style="font-size: 3.4rem;font-weight: 700;color:#409EFF;">重置密码</span>
        </div>
        <div class="content">
            <div style="width: 100%;">
                <van-form>
                  <van-field
                      v-model="phone"
                      center
                      name="手机"
                      label="手机"
                      placeholder="请输入手机号"
                      disabled
                  />
                    <van-field
                        v-model="code"
                        center
                        type="digit"
                        name="短信验证码"
                        label="短信验证码"
                        placeholder="短信验证码"
                        @input="formatterCode"
                    >
                        <template #button>
                            <van-button size="small" @click="getIdentifyCode" :disabled="sendDisabled"  color="linear-gradient(to right, #10E3E9, #409EFF)"
                                        style="color: #fff;width: 90px;height: 35px;">{{ sendText }}
                            </van-button>
                        </template>
                    </van-field>

                    <van-field
                        v-model="password"
                        type="password"
                        center
                        name="密码"
                        label="新的密码"
                        placeholder="输入新的密码">
                    </van-field>
                  <van-field
                      v-model="repeatPassword"
                      type="password"
                      center
                      name="密码"
                      label="确认密码"
                      placeholder="再次输入密码"
                      @blur="checkPass"
                  >
                  </van-field>
                    <div style="margin:5rem 5px 2rem;">

                        <van-button @click="updateLoginPass" block round native-type="submit"  color="linear-gradient(to right, #10E3E9, #409EFF)"
                                    style="color: #fff;font-size: 18px;">提 交
                        </van-button>

                    </div>
                </van-form>
            </div>
        </div>
        <div class="footer" v-if="false">
            <span style="font-size: 14px;color: #9A9A9A;">技术支持：深圳市诺康云科技有限公司</span>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    import SIdentify from '@/components/identify'
    import {Toast, Dialog} from 'vant';
    import {getCode, updateLoginPass} from '@/api/module/user'
    import {encrypt, decrypt} from '../../assets/utils/cryptoUtil.js'
    import {HideCardIdStr} from '@/assets/utils/utils'
    import router from "@/router";
    import {saveToken} from "@/assets/utils/cache";
    import cookies from 'js-cookie'


    export default {
        components: {},
        props: [],
        data() {
            return {
                copyrightShow:window.g.VUE_APP_COPYRIGHT_ISSHOW,
                copyrightText:window.g.VUE_APP_COPYRIGHT_TEXT,
                sendText: '发送验证码',
                sendDisabled: false,
                phone: '',//页面传递的手机号
                password: '',//密码
                repeatPassword:'',
                code: '',
                hospitalname: window.g.VUE_APP_HOSPITALNAME,
                currentPhone: '',//当前登录手机号码，用于校验
                currentPassword: '',//当前登录密码，用于校验
                currentCode: '',//当前登录验证码，用于校验
                actionsUserShow: false,
                actionsUser:[],//手机号关联帐号动作面板数据
                userList:[],//手机号关联帐号数据
                registOpen:window.g.VUE_APP_REGISTER_OPEN,
                passComplex:window.g.VUE_APP_PASS_COMPLEX,//是否启用密码复杂性验证
            };
        },
        mounted() {
          this.phone = decrypt(this.$route.query.phone)
        },
        methods: {
            //获取短信验证码
            getIdentifyCode() {
                let param = {
                    phone: encrypt(this.phone),
                    name: this.hospitalname
                }
                if (this.phone == '') {
                    Toast.fail('请填写手机号码！');
                    return
                }

                if (!this.phonevalidate()) {
                    return
                }
                getCode(param).then(res => {
                    if (res.code == 200) {
                        Toast.success(res.msg,{duration:2000});
                        if(res.data == 1){
                            this.sendDisabled = true
                            //发送之后，60秒后才能重新发送
                            const start = (e) => {
                                let timer = null
                                timer = setInterval(() => {
                                    this.sendText = '重发(' + e + ')'
                                    e--
                                    if (e < 0) {
                                        clearInterval(timer)
                                        this.sendDisabled = false
                                        this.sendText = '发送验证码'
                                    }
                                }, 1000)
                            }
                            start(60)
                        }
                    }
                })
            },
            //修复ios 短信验证码自动填充时总是被复制两遍
            formatterCode(val){
                if(val.length > 6){
                    this.code = val.substr(0,6)
                }
            },
          //修改密码
          updateLoginPass() {
                if (this.phone == '') {
                    Toast.fail('请填写手机号码');
                    return
                }
                if (!this.phonevalidate()) {
                    return
                }
                if(!this.checkPass()){
                  return;
                }
                //密码复杂性验证
                if(this.passComplex){
                  //包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12
                  let reg = new RegExp("^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*,\.])[0-9a-zA-Z!@#$%^&*,\\.]{6,12}$","g")
                  if(!reg.test(this.password)){
                    Dialog({
                      message: "密码不符合复杂性要求：包含数字、字母大小写、特殊符号（!@#$%^&*），总长度6-12",
                      theme: 'round-button',
                    });
                    // Toast.fail('密码不符合复杂性要求：包含数字和字母，以及@#$三种符号，总长度6-8，必须包含2位及以上的字母，必须包含数字');
                    return;
                  }
                }
                let param = {
                    id:this.id,
                    phone: encrypt(this.phone),
                    code: this.code,
                    password:this.password
                }
                this.currentPhone = this.phone
                updateLoginPass(param).then(res => {
                    if (res.code == 200) {
                        if (res.data == null) {
                            Dialog.alert({
                                title: '提示',
                                message: res.msg,
                            }).then(() => {
                                // on close
                            });
                        } else {
                            //修改密码成功直接登录
                            Toast.success(res.msg);
                            this.$router.push({name: 'login'})
                        }
                    }
                })
            },
            //手机号码验证
            phonevalidate() {
                let myreg = /^((0\d{2,3}-\d{7,8})|(0\d{2,3}\d{7,8})|(\d{7,8})|(1[3456789]\d{9}))$/
                if (!myreg.test(this.phone)) {
                    Toast.fail('请填写正确的手机号码');
                    return false;
                } else {
                    return true;
                }
            },
          //检查两次输入的密码是否一致
            checkPass(){
              if(this.code == ""){
                Toast.fail('请输入验证码');
                return false;
              }
              if(this.repeatPassword=="" || this.password == ""){
                Toast.fail('请输入密码');
                return false;
              }
              if(this.repeatPassword!=this.password){
                Toast.fail('两次输入的密码不一致，请重新输入');
                return false;
              }
              return true;
            }
        }
    };
</script>

<style lang="scss" scoped>
  .footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
  }

  .login-active {
    background: #F7937B;
    color: #fff;
  }

  .login-items {
    width: 49.5%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
    font-weight: 500;
  }

  .login-top {
    width: 100%;
    height: 100px;
    background: #e1e5df;
    display: flex;
    flex-flow: row;
    justify-content: space-around;
  }

  .login {
    background: #F0EFF4;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;

    &-b {
      color: red;
    }
  }
  .copyright{
    text-align: center;
    font-size: 2em;
    color: #999;
    padding: 2em;
  }
  .copyright .link{
    text-decoration: underline;
    color: #999;
  }
</style>
